import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=7e5a1b70&"
import script from "./BoxIcon.vue?vue&type=script&lang=js&"
export * from "./BoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports